import styled from '@emotion/styled';

/**
 * Обёртка для основного содержимого элемента.
 */
export const Inner = styled.div`
  padding: 1.25rem;
`;
